export default defineNuxtPlugin((nuxtApp) => {
    const i18n = nuxtApp.vueApp.config.globalProperties.$i18n;

    watch(
        () => i18n.locale,
        (newLocale) => {
            useHead({
                htmlAttrs: {
                    lang: newLocale
                }
            });
        },
        { immediate: true }
    );
});